import { Spinner } from "@/components/ui/Spinner";

export function Loading() {
  return (
    <div className="flex h-full flex-col items-center justify-center p-16">
      <Spinner className="size-10 text-primary" />
    </div>
  );
}
